import { Component, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { GetSituFacadeResponse, SituViewWebApiClient, GetSituFacadeRequest, ProductName, GetHomeRequest, GetHomeResponse } from 'situview-webapi-client';
import { ActivatedRoute, Params } from '@angular/router';
import { SituFacadeReadonlyComponent } from '../situ-facade-readonly/situ-facade-readonly.component';
import { SituViewReadonlyComponent } from '../situ-view-readonly/situ-view-readonly.component';
import { SituProductReadonlyComponent } from '../situ-product-readonly/situ-product-readonly.component';
import { SituPlanReadonlyComponent } from '../situ-plan-readonly/situ-plan-readonly.component';
import { Guid } from 'guid-typescript';
import { SituRenderReadonlyComponent } from '../situ-render-readonly/situ-render-readonly.component';
import { SituRenderServiceWebApiClient } from 'siturenderservice-webapi-client';

@Component({
  selector: 'situ-readonly-factory',
  template: '<ng-container #dynamicComponentContainer></ng-container>'
})
export class SituReadonlyFactoryComponent {
  constructor(
    private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    private situViewClient: SituViewWebApiClient,
    private renderServiceClient: SituRenderServiceWebApiClient) {}

  ngOnInit(): void {
    let renderedOutputId;
    if (this.route.snapshot.params['id']) {
      renderedOutputId = this.route.snapshot.params['id'];
    }

    if (!renderedOutputId) {
      return;
    }

    this.determineTypeAndAssign(renderedOutputId, this.route.snapshot.params);
  }

  private loadComponent(component: any, params: any) {
    this.viewContainerRef.clear();

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    const componentRef = this.viewContainerRef.createComponent(componentFactory);

    const instance: any = componentRef.instance;
    instance.routeParams = params;
  }

  determineTypeAndAssign(renderedOutputId: string, params: Params) {
    this.getRenderedOutputById(renderedOutputId)
      .then((getFacadeResponse: GetSituFacadeResponse) => {
        if (getFacadeResponse?.success && getFacadeResponse?.artifactId && getFacadeResponse.artifactId !== Guid.EMPTY) {
          params = { ...params, id: getFacadeResponse.artifactId };
          if (getFacadeResponse.productName === ProductName.Facade) {
            this.loadComponent(SituFacadeReadonlyComponent, params);
          } else if (getFacadeResponse.productName === ProductName.Plan) {
            this.loadComponent(SituPlanReadonlyComponent, params);
          } else if (getFacadeResponse.productName === ProductName.Render) {
            this.loadComponent(SituRenderReadonlyComponent, params);
          } else {
            this.loadComponent(SituViewReadonlyComponent, params);
          }
        } else {
          this.renderServiceClient.getSituConnectType(renderedOutputId)
            .then((connectType: string | undefined) => {
              const permittedConnectTypes = ["draftsitulinkpanoramas", "situlinkpanoramas", "hdsitulinkpanoramas", "draftfacade", "facade", "hdfacade"]
              if (!connectType || !permittedConnectTypes.includes(connectType.toLowerCase())) {
                this.getHomeById(renderedOutputId)
                  .then((response: GetHomeResponse) => {
                    if (response.success && response.files?.find(x => x.fileName?.toLowerCase() === "product.glb")) {
                      this.loadComponent(SituProductReadonlyComponent, params);
                    } else {
                      this.loadComponent(SituViewReadonlyComponent, params);
                    }
                  })
                  .catch((err: any) => {
                    this.loadComponent(SituViewReadonlyComponent, params);
                  });
              } else {
                switch(connectType.toLowerCase()) {
                  case "draftsitulinkpanoramas":
                  case "situlinkpanoramas":
                  case "hdsitulinkpanoramas":
                    this.loadComponent(SituViewReadonlyComponent, params);
                    break;
                  case "draftfacade":
                  case "facade":
                  case "hdfacade":
                    this.loadComponent(SituFacadeReadonlyComponent, params);
                }
              }
            })
        }
      })
      .catch((err: any) => {});
  }

  private getRenderedOutputById(renderedOutputId: string): Promise<GetSituFacadeResponse> {
    let request = new GetSituFacadeRequest();
    request.renderedOutputId = renderedOutputId;
    return this.situViewClient.getSituFacade(request);
  }

  private getHomeById(artifactId: string) {
    let request = new GetHomeRequest();
    request.homeId = artifactId;

    return this.situViewClient.getHome(request);
  }
}